import { useEffect, useRef, useState } from 'react';
import { useEventListener } from 'usehooks-ts';

export enum Direction {
  Up = 'up',
  Down = 'down',
}

type ScrollPosition = {
  x: number;
  y: number;
  direction: Direction | null;
};

export default function useWindowScroll() {
  const [scroll, setScroll] = useState<ScrollPosition>({
    x: window.scrollX,
    y: window.scrollY,
    direction: null,
  });

  const [scrollDirection, setScrollDirection] = useState<Direction | null>(
    null,
  );

  useEventListener('scroll', () => {
    setScroll({
      x: window.scrollX,
      y: window.scrollY,
      direction: null,
    });
  });

  const [isScrolling, setIsScrolling] = useState(false);
  const lastYRef = useRef(scroll.y);
  const accumulatedDeltaY = useRef(0);
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const deltaY = Math.abs(scroll.y - lastYRef.current);
    let direction: Direction | null = null;
    if (scroll.y > lastYRef.current) {
      direction = Direction.Down;
    } else if (scroll.y < lastYRef.current) {
      direction = Direction.Up;
    }
    lastYRef.current = scroll.y;

    accumulatedDeltaY.current += deltaY;

    if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);

    scrollTimeoutRef.current = setTimeout(() => {
      accumulatedDeltaY.current = 0;
      setIsScrolling(false);
      setScrollDirection(null);
    }, 500);

    if (accumulatedDeltaY.current >= 50) {
      setIsScrolling(true);
      setScrollDirection(direction);
    }
  }, [scroll.y]);

  return { isScrolling, scroll, direction: scrollDirection };
}
